import React from 'react'
import '../App'

const Footer = () => {
  return <div className='footer'>
    <p> Football Videos App 2022&copy</p></div>
  
}

export default Footer